import React, { useEffect, useState } from "react";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import "../../styles/diet/google-search.css";

const addressNameFormat = {
  street_number: "short_name",
  route: "long_name",
  locality: "long_name",
  administrative_area_level_1: "long_name",
  administrative_area_level_2: "short_name",
  country: "long_name",
  postal_code: "short_name",
  neighborhood: "short_name",
  political: "short_name",
  sublocality_level_1: "short_name",
};

const getAddressComp = function (place, type) {
  for (const component of place.address_components) {
    if (component.types.includes(type)) {
      return component[addressNameFormat[type]];
    }
  }
  return "";
};

export default function PlacesSearch({ handlePlaceChange }) {
  const [place, setPlace] = useState(null);
  const [inputKey, setInputKey] = useState(Date.now());

  useEffect(() => {
    if (place && place.value && place.value.place_id) {
      geocodeByAddress(place.label).then((results) => {
        let address1 =
          getAddressComp(results[0], "street_number") +
          " " +
          getAddressComp(results[0], "route");

        if (address1.trim().length <= 0) {
          address1 = getAddressComp(results[0], "neighborhood");
        }

        if (address1.trim().length <= 0) {
          address1 = getAddressComp(results[0], "sublocality_level_1");
        }

        let address2 = getAddressComp(results[0], "street_number");
        if (address2.trim().length <= 0) {
          address2 = getAddressComp(results[0], "political");
        }
        let addressObj = {
          address1: address1,
          address2: address2,
          city: getAddressComp(results[0], "locality"),
          state: getAddressComp(results[0], "administrative_area_level_1"),
          pincode: getAddressComp(results[0], "postal_code"),
          selectedCountry: getAddressComp(results[0], "country"),
        };

        getLatLng(results[0]).then((obj) => {
          addressObj = {
            ...addressObj,
            lat: obj.lat,
            long: obj.lng,
          };
          handlePlaceChange({
            ...addressObj,
            formatted_address: results[0].formatted_address,
          });
        });
      });
    }
  }, [place]);

  return (
    <div>
      <GooglePlacesAutocomplete
        key={inputKey}
        debounce="300"
        selectProps={{
          place,
          onChange: setPlace,
          placeholder: "Search your location",
          className: "google-search-container",
        }}
      />
    </div>
  );
}
